/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomFieldsDto
 */
export interface GetCustomFieldsDto {
    /**
     * 
     * @type {string}
     * @memberof GetCustomFieldsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomFieldsDto
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomFieldsDto
     */
    fields: Array<string>;
}

/**
 * Check if a given object implements the GetCustomFieldsDto interface.
 */
export function instanceOfGetCustomFieldsDto(value: object): value is GetCustomFieldsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function GetCustomFieldsDtoFromJSON(json: any): GetCustomFieldsDto {
    return GetCustomFieldsDtoFromJSONTyped(json, false);
}

export function GetCustomFieldsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomFieldsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'fields': json['fields'],
    };
}

export function GetCustomFieldsDtoToJSON(value?: GetCustomFieldsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'fields': value['fields'],
    };
}

